import { Component } from '@angular/core';
import { UsersService } from 'app/modules/user-management/services/users.service';
import { Router } from '@angular/router';

@Component({ standalone: false,
  selector: 'dashboard-card-link-list',
  templateUrl: './dashboard-card-link-list.component.html',
  styleUrls: ['./dashboard-card-link-list.component.scss']
})
export class DashboardCardLinkListComponent {


  constructor(
    protected usersService: UsersService,
    private router: Router,
  ) {

  }

  navigateMyELearning() {
    window.open("https://supportislearning.unicornlms.com/Login", "_blank");
  }
}
